import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPostbackSettings, createPostbackSettings } from "../../redux/slices/postbackSlice";
import Modal from "../../components/Modal/Modal";
import PostbackTable from "./PostbackTable";
import { useModal } from "../../shared/hooks/useModal";
import { Container } from "./PostbackStyles";

const Postback = () => {
  const { showModal, hideModal, isModalOpen } = useModal();
  const dispatch = useDispatch();
  const { postbackSetting, loading } = useSelector((state) => state.postback);
  //const [formData, setFormData] = useState(postbackSetting);
  const [formData, setFormData] = useState({
    timeInterval: 0,
    range: 0,
    pbPublisher: 0,
    pbMetaClick: 0,
    staticId: 1
  });
  //console.log(postbackSetting);

  // useEffect(() => {
  //   if (isModalOpen("postbackSetting")) {
  //     dispatch(getPostbackSettings());
  //   }
  // }, [isModalOpen, dispatch]);

  const handleClick = () => {
    showModal("postbackSetting");
    dispatch(getPostbackSettings());
    setFormData(postbackSetting);
  };

  useEffect(() => {
    if (postbackSetting) {
      setFormData({
        timeInterval: parseInt(postbackSetting.timeInterval),
        range: parseInt(postbackSetting.range),
        pbPublisher: parseInt(postbackSetting.pbPublisher),
        pbMetaClick: parseInt(postbackSetting.pbMetaClick),
        staticId: parseInt(postbackSetting.staticId)
      })
    }
  }, [postbackSetting]);
  //console.log(formData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "pbPublisher") {
      const publisherValue = Math.min(100, parseInt(value));
      setFormData((prev) => ({
        ...prev,
        pbPublisher: publisherValue,
        pbMetaClick: 100 - publisherValue // Automatically calculate pbMetaClick
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: parseInt(value) }));
    }
  };

  const handleSubmit = (e) => {
    // console.log(formData)
    // return
    e.preventDefault();
    dispatch(createPostbackSettings(formData)).then(() => hideModal("postbackSetting"));
  };

  return (
    <Container>
      <div className="header">
        <div className="texts">
          <h3>Monitor Postback</h3>
          <p>Track and review postbacks.</p>
        </div>

        <div className="link-buttons" style={{display:"none"}}>
          <button className="see-more" onClick={handleClick}>
            Settings
          </button>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen("postbackSetting")}
        label="Postback Settings"
        handleClose={() => hideModal("postbackSetting")}
      >
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Postback Time Interval (mins)</label>
            <input
              type="number"
              name="timeInterval"
              value={formData.timeInterval}
              onChange={handleChange}
              min="0"
            />
          </div>

          <div className="form-group">
            <label>Minimum Postback</label>
            <input
              type="number"
              name="range"
              value={formData.range}
              onChange={handleChange}
              min="0"
            />
          </div>

          <div className="form-group">
            <label>Postback (Publisher) %</label>
            <input
              type="number"
              name="pbPublisher"
              value={formData.pbPublisher}
              onChange={handleChange}
              min="0"
              max="100"
            />
          </div>

          <div className="form-group">
            <label>Postback (MetaClick) %</label>
            <input
              type="number"
              name="pbMetaClick"
              value={formData.pbMetaClick}
              onChange={handleChange}
              min="0"
              max="100"
              disabled
            />
          </div>

          <div className="submit">
          <div></div>
          <div className="submit-buttons">
            {/* <Link to='/campaigns'>
            <button className="cancel" type="submit" disabled={loading}>
              Pay Later
            </button></Link> */}
            <button className="add-campaign" type="submit" disabled={loading}>
            {loading ? "Saving..." : "Save Settings"}
            </button>
          </div>
        </div>

          {/* <button type="submit" disabled={loading}>
            {loading ? "Saving..." : "Save Settings"}
          </button> */}
        </form>
      </Modal>

      <PostbackTable />
    </Container>
  );
};

export default Postback;
